import { Routes } from '@angular/router';

import { DashboardComponent } from '../../dashboard/dashboard.component';

import { AuthGuard } from 'app/guards/auth.guard';


let privilege1 = ['1']

export const ConfigLayoutRoutes: Routes = [

    { path: 'dashboard',      component: DashboardComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 } },
    // {
    //     path: 'empresaSeg',
    //     component: EmpresaSegComponent,
    //     children: [
    //         { path: 'listado', component: ListadoComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevaEmpresa', component: NuevoEmpresaComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'parametro/:id', component: ParametroComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // {
    //     path: 'sistema',
    //     component: SistemaComponent,
    //     children: [
    //         { path: 'listado', component: ListadoSistemaComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevoSistema', component: NuevoSistemaComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // {
    //     path: 'rol',
    //     component: RolComponent,
    //     children: [
    //         { path: 'listado', component: ListadoRolComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevoRol', component: NuevoRolComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // { path: 'acceso', 
    //   component: AccesoComponent,
    //     children: [
    //         { path: 'listado', component: ListadoAccesoComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevoAcceso', component: NuevoAccesoComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},        
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // {
    //     path: 'permiso',
    //     component: PermisoComponent,
    //     children: [
    //         { path: 'listado', component: ListadoPermisoComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevoPermiso', component: NuevoPermisoComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // {
    //     path: 'componentes',
    //     component: ComponentesComponent,
    //     children: [
    //         { path: 'listado', component: ListadoComponenteComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevoComponente', component: NuevoComponenteComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'permisoComponente', component: PermisoComponenteComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // {
    //     path: 'guias',
    //     component: GuiasComponent,
    //     children: [
    //         { path: 'listado', component: ListadoGuiaComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },
    // { path: 'usuarios',     component: UsuarioComponent,
    //     children: [
    //         { path: 'listado', component: ListaUsuarioComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'nuevoUsuario', component: NuevoUsuarioComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: 'editarUsuario', component: NuevoUsuarioComponent ,canActivate: [AuthGuard],data: {privileges: privilege1 }},
    //         { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    //     ]
    // },

    { path: '', redirectTo: 'dashboard', pathMatch: 'full', }
];
